module.exports = __webpack_public_path__ + "img/time-check.4dd68b1.svg";